module.exports = __webpack_public_path__ + "static/media/user_color.5e41acf3.svg";